import type { RouteType } from '@rfc/rfc-components-library/types'

import { ADMIN_EVENTS_ROUTES, ADMIN_STATS_ROUTE } from '@/router/routes'
import { EEventsPerm } from '../../types/permissions/EventsPermissionsEnum'
import AdminEventsTable from '../../views/AdministrationView/AdminEvents/AdminEventsTable.vue'
import AdminStatsDashboard from '../../views/AdministrationView/AdminEvents/AdminStatsDashboard.vue'
import EventsCreateView from '../../views/EventsView/EventsCreateView.vue'
import EventsDetailView from '../../views/EventsView/EventsDetailView.vue'
import { ADMIN_STATS_ROUTE_NAME, EAdminEventsRoutes } from '../admin/AdminRoutesEnum'
import checkpointsRoutes from './checkpointsRoutes'

const routes: RouteType[] = [
    {
        path: ADMIN_EVENTS_ROUTES.baseUrl,
        name: EAdminEventsRoutes.ADMIN_EVENTS_TABLE,
        component: AdminEventsTable,
        meta: {
            title: 'menu.events',
            permission: EEventsPerm.EVENTS_VIEW
        }
    },
    {
        path: ADMIN_EVENTS_ROUTES.detailUrl,
        name: EAdminEventsRoutes.ADMIN_EVENTS_DETAIL,
        component: EventsDetailView,
        meta: {
            title: 'menu.events',
            permission: EEventsPerm.EVENTS_VIEW
        },
        children: checkpointsRoutes
    },
    {
        path: ADMIN_EVENTS_ROUTES.createUrl,
        name: EAdminEventsRoutes.ADMIN_EVENTS_CREATE,
        component: EventsCreateView,
        meta: {
            title: 'menu.events',
            permission: EEventsPerm.EVENTS_EDIT
        }
    },
    {
        path: ADMIN_STATS_ROUTE,
        name: ADMIN_STATS_ROUTE_NAME,
        component: AdminStatsDashboard,
        meta: {
            title: 'menu.events'
        }
    }
]

export default routes
